$(function () {
    var currentHash = "#1949"
    $(document).scroll(function () {
        $('.anchor_tags').each(function () {
            if (!(/Mobi/.test(navigator.userAgent))) {
            var top = window.pageYOffset;
            var distance = top - $(this).offset().top;
            var hash = $(this).attr('href');
            // 30 is an arbitrary padding choice, 
            // if you want a precise check then use distance===0
            if (distance < 35 && distance > -35 && currentHash != hash) {
                window.location.hash = (hash);
                currentHash = hash;
            }
            }
        });
    });
});

var nextbtn = $('#nextAnchorButton');
var prevbtn = $('#prevAnchorButton');
var firstbtn = $('#firstAnchorButton');
var lastbtn = $('#lastAnchorButton');

$(window).scroll(function() {
  if (!(/Mobi/.test(navigator.userAgent))) {

  if ($(window).scrollTop() > 300) {
    nextbtn.addClass('show');
    prevbtn.addClass('show');
    firstbtn.addClass('show');
    lastbtn.addClass('show');
  } else {
    nextbtn.removeClass('show');
    prevbtn.removeClass('show');
    firstbtn.removeClass('show');
    lastbtn.removeClass('show');
  }
  }
});

function goToNextAnchor() {
  var anchors = document.anchors;
  var loc = window.location.href.replace(/#.*/,'');
  var nextAnchorName;

  // Get name of the current anchor from the hash
  // if there is one
  var anchorName = window.location.hash.replace(/#/,'');

  // If there is an anchor name...
  if (anchorName) {

    // Find current element in anchor list, then
    // get next anchor name, or if at last anchor, set to first
    for (var i=0, iLen=anchors.length; i<iLen; i++) {
      if (anchors[i].name == anchorName) {
        nextAnchorName = anchors[++i % iLen].name;
        break;
      }
    }
  }

  // If there was no anchorName or no match,
  // set nextAnchorName to first anchor name
  if (!nextAnchorName) {
    nextAnchorName = anchors[0].name;
  }

  // Go to new URL
  window.location.href = loc + '#' + nextAnchorName;
}

function goToPrevAnchor() {
  var anchors = document.anchors;
  var loc = window.location.href.replace(/#.*/,'');
  var nextAnchorName;

  // Get name of the current anchor from the hash
  // if there is one
  var anchorName = window.location.hash.replace(/#/,'');

  // If there is an anchor name...
  if (anchorName) {

    // Find current element in anchor list, then
    // get next anchor name, or if at last anchor, set to first
    for (var i=0, iLen=anchors.length; i<iLen; i++) {
      if (i == 0) 
      {
        nextAnchorName = anchors[anchors.length-1].name;
      }
      else if (anchors[i].name == anchorName) {
        nextAnchorName = anchors[--i % iLen].name;
        break;
      }
    }
  }

  // If there was no anchorName or no match,
  // set nextAnchorName to first anchor name
  if (!nextAnchorName) {
    nextAnchorName = anchors[anchors.length-1].name;
  }

  // Go to new URL
  window.location.href = loc + '#' + nextAnchorName;
}

function goToLast() {
  var anchors = document.anchors;
  var loc = window.location.href.replace(/#.*/,'');
  window.location.href = anchors[anchors.length-1];
}

function goToFirst() {
  var anchors = document.anchors;
  var loc = window.location.href.replace(/#.*/,'');
  window.location.href = anchors[0];
}

(function($){
    if ( "onhashchange" in window ) {
        var hashHandler = function(){
            var hash = window.location.hash.substring( 1 );
            if ( !hash )
                return;

            var offset = -80;
            var sel = '[id="' + hash + '"], a[name="' + hash + '"]';
            var currentOffset = $( sel ).offset().top;

            $( window ).scrollTop( currentOffset + offset );
        };
        window.addEventListener("hashchange", hashHandler, false);
        window.addEventListener("load", hashHandler, false);
    }
})(window.jQuery);